module.exports = __webpack_public_path__ + "static/media/GuessThatFruit.41db0f4f.png";